<footer class="footer-menu">
  <nav class="navbar navbar-expand-md navbar-custom">
    <ul class="navbar-nav mx-auto text-center">
      <li class="nav-item">
        <a
          class="nav-link"
          href={{ktbl}}
          target="_blank"
          >KTBL-Startseite
        </a>
      </li>

      <span class="trenner">|</span>
      <li class="nav-item">
        <a
          class="nav-link"
          href={{kontakt}}
          target="_blank"
          >Kontakt
        </a>
      </li>
      <span class="trenner">|</span>
      <li class="nav-item">
        <a
          class="nav-link"
          href={{impressum}}
          target="_blank"
          >Impressum
        </a>
      </li>
      <span class="trenner">|</span>
      <li class="nav-item">
        <a
          class="nav-link"
          href={{nutzungsbedingungen}}
          target="_blank"
          >Nutzungsbedingungen
        </a>
      </li>
      <span class="trenner">|</span>
      <li class="nav-item">
        <a
          class="nav-link"
          href={{datenschutzerklaerung}}
          target="_blank"
          >Datenschutzerklärung</a
        >
      </li>
    </ul>
  </nav>
</footer>
